import './module/_parallax' // Parallax.js https://matthew.wagerfield.com/parallax/

const topPara = document.getElementById('topPara')
if (topPara) {
  const parallaxInstance = new Parallax(topPara, {
    // relativeInput: true,// マウス入力を相対的に反映する
    // invertX: false, // 入力の反転を解除する
    // invertY: false, // 入力の反転を解除する
  })
}
